export default __webpack_public_path__ + "static/flag-gb-0b4e6af0e6d3903b1d9e6d8757f6a1fb.svg";